import { ButtonGhost } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledLearnMoreButton = styled(ButtonGhost)`
  background-color: ${({ theme }) => theme.colors.BLUE_50};
`
